/* PDP research dossier — the readouts count up when the panel comes into view.
 *
 * The numbers are rendered by Liquid and are correct before this runs; the
 * script only animates from zero to the printed value, so with it missing or
 * reduced motion on, the figures are simply there. Each figure carries its
 * target in `data-count` and its precision in `data-decimals`, and the text
 * is rebuilt from those, never parsed back out of the DOM. */
(function () {
  var panels = document.querySelectorAll('[data-research]');
  if (!panels.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  function format(value, decimals) {
    return value.toFixed(decimals);
  }

  function run(panel) {
    var figures = panel.querySelectorAll('[data-count]');
    Array.prototype.forEach.call(figures, function (el, i) {
      var target = parseFloat(el.getAttribute('data-count'));
      var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
      if (isNaN(target)) return;
      var duration = 1300 + i * 120;
      var start = null;
      el.textContent = format(0, decimals);
      function frame(now) {
        if (start === null) start = now;
        var t = Math.min(1, (now - start) / duration);
        // ease-out quart: fast off the line, settling gently on the figure.
        var eased = 1 - Math.pow(1 - t, 4);
        el.textContent = format(target * eased, decimals);
        if (t < 1) window.requestAnimationFrame(frame);
        else el.textContent = format(target, decimals);
      }
      window.requestAnimationFrame(frame);
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      run(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.35 });

  Array.prototype.forEach.call(panels, function (panel) { observer.observe(panel); });
})();

/* Phone track index — the dossier's folder tabs (2026-09-03, replacing the
 * bars). Scroll-snap does the carousel itself; this marks the tab of the
 * readout in view (root is the track, a slide counts past 60% visible) and
 * scrolls the track when a tab is tapped. It also flags the panel as
 * `is-tracked`, which is what shows the tabs and lets the in-slide label step
 * aside - so without this file the panel is the plain readouts, labels on.
 * On desktop the track is a grid with nothing to scroll: the tabs stay
 * display:none and the observer changes nothing visible. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-research]').forEach(function (panel) {
    var track = panel.querySelector('[data-research-track]');
    var tabs = Array.prototype.slice.call(panel.querySelectorAll('[data-research-tab]'));
    if (!track || !tabs.length) return;
    var slides = track.children;

    function mark(i) {
      tabs.forEach(function (tab, k) {
        if (k === i) tab.setAttribute('aria-current', 'true');
        else tab.removeAttribute('aria-current');
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          mark(Array.prototype.indexOf.call(slides, e.target));
        });
      }, { root: track, threshold: 0.6 });
      Array.prototype.forEach.call(slides, function (s) { io.observe(s); });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        var slide = slides[i];
        if (!slide) return;
        var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        var left = slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - pad;
        track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
        mark(i);
      });
    });

    panel.classList.add('is-tracked');
  });
})();
